const MonthlyReport = {
  Title: "MonthlyReport.Title",
  FooterAttribution: "MonthlyReport.FooterAttribution",
  FooterTagline: "MonthlyReport.FooterTagline",
  FooterCompany: "MonthlyReport.FooterCompany",
  NotFound: "MonthlyReport.NotFound",
  LoadFailed: "MonthlyReport.LoadFailed",
  Period: "MonthlyReport.Period",
  BackToList: "MonthlyReport.BackToList",
  SettingsTitle: "MonthlyReport.SettingsTitle",
  SettingsRecipientSection: "MonthlyReport.SettingsRecipientSection",
  SettingsLoadFailed: "MonthlyReport.SettingsLoadFailed",
  SettingsRetry: "MonthlyReport.SettingsRetry",
  SettingsRole: "MonthlyReport.SettingsRole",
  SettingsRoleDescription: "MonthlyReport.SettingsRoleDescription",
  SettingsIsEnabled: "MonthlyReport.SettingsIsEnabled",
  SettingsIsEnabledDescription: "MonthlyReport.SettingsIsEnabledDescription",
  SettingsRole_0: "MonthlyReport.SettingsRole_0",
  SettingsRole_1: "MonthlyReport.SettingsRole_1",
  SettingsRole_2: "MonthlyReport.SettingsRole_2",
  SettingsRole_3: "MonthlyReport.SettingsRole_3",
  SettingsRole_4: "MonthlyReport.SettingsRole_4",
  }
export default MonthlyReport;